import { render, staticRenderFns } from "./testCreation.vue?vue&type=template&id=71a50286&scoped=true"
import script from "./testCreation.vue?vue&type=script&lang=js"
export * from "./testCreation.vue?vue&type=script&lang=js"
import style0 from "./testCreation.vue?vue&type=style&index=0&id=71a50286&prod&lang=scss"
import style1 from "./testCreation.vue?vue&type=style&index=1&id=71a50286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a50286",
  null
  
)

export default component.exports